import { render, staticRenderFns } from "./project-alternatives.vue?vue&type=template&id=1950becc&scoped=true&"
import script from "./project-alternatives.vue?vue&type=script&lang=js&"
export * from "./project-alternatives.vue?vue&type=script&lang=js&"
import style0 from "./project-alternatives.vue?vue&type=style&index=0&id=1950becc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950becc",
  null
  
)

export default component.exports